<template>
  <side-panel-inner headerTitle="Approve document">
    <template slot="actions" v-if="!loading">
      <base-button v-if="showBackButton" iconBefore="back" @click="$router.go(-1)">Back</base-button>
      <base-button success @click="approveDocument">Complete Approval</base-button>
    </template>

    <div v-if="!loading">
      <document-meta :document="document"></document-meta>
      <hr>

      <div v-if="fileReady">
        <pdf-preview
          v-if="document.current_version.file.mime_type == 'application/pdf'"
          :fileId="file.id"
        ></pdf-preview>
      </div>
    </div>
    <loading v-else></loading>
  </side-panel-inner>
</template>

<script>
import { mapGetters } from 'vuex';
import PdfPreview from '@/components/PdfPreview';

let backButton = false;

export default {
  name: 'document-approve',

  components: {
    PdfPreview,
  },
  data() {
    return {
      loading: true,
      showBackButton: backButton,
      fileReady: false,
    };
  },

  beforeRouteEnter(to, from, next) {
    if (from.meta.openPanel) {
      backButton = true;
    } else {
      backButton = false;
    }

    next();
  },

  beforeMount() {
    const vm = this;

    if (vm.$route.params.id) {
      const docId = vm.$route.params.id;
      vm.$store.dispatch('documents/read', docId).then((response) => {
        console.log(response);
        vm.loading = false;
      });
    }

    // so that the background isn't empty...
    if (!this.$store.state.documents[this.$store.state.documents.docType.plural]) {
      this.$store.dispatch('documents/list');
    }
  },

  methods: {
    approveDocument() {
      const vm = this;
      const documentId = vm.document.id;
      const versionId = this.$route.params.versionId;

      vm.loading = true;

      vm.$store
        .dispatch('documents/approveDocument', {
          documentId,
          versionId,
        })
        .then((response) => {
          vm.$store.dispatch('CLOSE_PANEL');
        });
    },
  },

  computed: {

    ...mapGetters('documents', ['document']),

    file() {
      return this.document.current_version.file.link;
    },
    versionId() {
      // if there is something in route, use that
      if (this.$route.params.versionId) {
        return this.$route.params.versionId
      }
      //else, fall back to current_version
      if (this.document.current_version) {
        return this.document.current_version.id
      }

      return null;
    }
  },
};
</script>

